<script>

import {axios} from '../../mixins';
import FarmsForm from './Form.vue';
import {Alerts} from "../../mixins/Alerts";

export default {

  name: 'FarmsCreate',

  components: {
    FarmsForm,
  },

  mixins: [axios],

  props: {
    userId: {
      type: Number,
      required: true,
    },
    mapboxToken: {
      type: String,
      required: true,
    },
    questionsData: {
      type: Object,
      required: true,
    },
    cropUseData: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      alerts: new Alerts(),
      enrollmentDefaults: {
        "HU Question #1":"null",
        "HU Question #2":"null",
        "HU Question #3":{
          "American Indian or Alaska Native":"null",
          "Asian":"null",
          "Black or African American":"null",
          "Native Hawaiian or Other Pacific Islander":"null",
          "White":"null"
        },
        "HU Question #4":"null",
        "HU Question #5":"null",
        "HU Question #6":"null",
        "HU Question #7":"null"
      }
    };
  },

  created() {
  },

  methods: {
    storeResource(resource) {
      this.alerts.initialize()
      if (resource.type) {
        this.post('/farms', resource.data).then((response) => {
          let id = response.data.resource.id
          location.href = '/?user_id=' + this.userId + '&farmIndex=' + id

        }).catch((errors) => {
          this.alerts.recordErrors(errors.response.data.errors)
        });
      }
    },

    cancel() {
      this.$emit('getData', null);
    }
  },
};

</script>

<template>
  <div class="flex flex-col">
    <div class="bg-primary rounded-lg">
      <FarmsForm :resource="{type:'farms', id:null, data:{user_id: userId, hu_selections: enrollmentDefaults}}" :mapboxToken="mapboxToken"
                 :locked="false"
                 @store="storeResource"
                 @getData="cancel"
                 :alerts="alerts"
                 :questions-data="this.questionsData"
                 :cropUseData="this.cropUseData">
        <template #create-farm="">
          <slot name="create-farm"></slot>
        </template>
      </FarmsForm>
    </div>
  </div>
</template>